module.exports = require("npm:isarray@0.0.1/index.js");